import React, { useState } from 'react';

import { Box, ExpandPanel, ExpandLink, Text, Typography } from '@blueprint/ui';
const ExpandPanelWithProps = ({ title, content }) => {
    const [cursor, setCursor] = useState('default');

    const [open, setOpen] = React.useState(false);
    return (
        <Box
            style={{ cursor: cursor }}
            display='flex'
            flexDirection='column'
            border='1px solid grey'
            padding='10px'
            marginBottom='10px'
            onMouseEnter={() => {
                setCursor('pointer');
            }}
            onMouseLeave={() => {
                setCursor('default');
            }}
            onClick={() => setOpen(!open)}
            tabIndex='0'
            onKeyPress={(event) => {
                if (event.charCode === 13) {
                    setOpen(!open);
                }
            }}
        >
            <ExpandPanel open={open} toggleButton={<Box paddingLeft={2}><Text>{title}</Text></Box>}>
                <Box padding={2}><Typography variant='body1'>{content}</Typography></Box>
            </ExpandPanel>
        </Box>
    );
};

export default ExpandPanelWithProps;
